export const VIRTUAL_INDEX_ATTRIBUTE = 'data-fdt-index';